import { InjectionToken } from '@angular/core';
import { IMapFacadeConfig } from './map-config.model';

export const mapFacadeConfig: InjectionToken<IMapFacadeConfig> = new InjectionToken('map-facade-config');



// WEBPACK FOOTER //
// C:/Users/user/projects/ansyn/src/app/packages/map-facade/models/map-facade.config.ts